'use strict';

var Omnibar = (function () {

    var GetPropertyLevelHelpLink = function (location) {
        var page;
        if (location.pathname.split("/").length === 3 && location.pathname.indexOf("/leads") < 0) {
            page = "L2L-" + location.pathname.replace(/\/\d+/g, '').split("/")[1];
        }
        else if (location.pathname.indexOf("?") >= 0 || location.pathname.split("/").length === 2) {
            page = "L2L-" + location.pathname.split("/")[1];
        }
        else if (location.pathname.split("/").length === 3) {
            page = "L2L-" + location.pathname.replace(/\/\d+/g, '').split("/")[2];
        }
        else {
            page = "L2L-" + location.pathname.split("/")[1] + "/" + location.pathname.split("/")[2];
        }
        page = page.replace(/\/\d+/g, '');
        document.querySelector('omnibar-unified-help').helpQuery = "pg=" + page + "&vr=40&scrver=350";
        return page;
    };

    return {
        GetPropertyLevelHelpLink: GetPropertyLevelHelpLink
    };
})();